import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bulkCreateFilteredFollowUps } from '../api/contacts';
import type { BulkFilteredFollowUpPayload } from '../types';
import { notification } from 'antd';
import { ApiError } from '../../../lib/api/error';

export function useBulkFilteredFollowUp(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: BulkFilteredFollowUpPayload) => bulkCreateFilteredFollowUps(data),
    onSuccess: (response) => {
      if (response.failedCount === 0) {
        notification.success({
          message: 'Follow-ups created',
          description: `${response.successCount} follow-up(s) created successfully.${
            response.skippedCount > 0
              ? ` ${response.skippedCount} skipped (existing follow-ups).`
              : ''
          }`,
        });
      } else {
        notification.warning({
          message: 'Follow-ups created with errors',
          description: `${response.successCount} created, ${response.skippedCount} skipped, ${response.failedCount} failed.`,
          duration: 0,
        });
      }

      void queryClient.invalidateQueries({ queryKey: ['contacts'] });
      void queryClient.invalidateQueries({ queryKey: ['taskItems'] });
      void queryClient.invalidateQueries({ queryKey: ['task-dashboard'] });

      onSuccess?.();
    },
    onError: (error: unknown) => {
      notification.error({ message: ApiError.fromAxiosError(error).message });
    },
  });
}
